import { CustomModal } from 'app/shared/customModal/customModal';
import { LendingActions } from 'app/modules/lending/components/actions';
import React, { useContext, useState } from 'react';
import {
    ArrowDownOutlined,
    ArrowUpOutlined,
    MinusOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import { Button, Collapse, Input, Space, Switch } from 'antd';
import { connect } from 'react-redux';
import { Context } from 'app/index';
import { filter, findIndex, map } from 'underscore';
import { swapArrayLoc } from 'app/modules/setting/components/footer';
import { v4 as uuid } from 'uuid';
import { MenuTypes } from 'app/components/navbar/Navbar';
import { fetchFrontOptions } from 'app/modules/setting/actions/previewSideBar';

const { Panel } = Collapse;

function MenuCompactModal({ onSave: onSaveAction, isAdmin, isShowActions }) {
    const {
        settings: {
            navbar: { settings, setSettings },
        },
    } = useContext(Context);
    const [visible, setVisible] = useState(false);
    function onCancel() {
        setVisible(false);
    }

    function onEdit() {
        setVisible(true);
    }

    function onSave() {
        onSaveAction(settings, () => setVisible(false));
    }

    function onDiscard() {
        setSettings((prevState) => ({
            ...prevState,
            settings: prevState.snapshot,
        }));
    }

    return (
        <>
            <CustomModal
                title={'Настройки компактного меню'}
                open={visible}
                onCancel={onCancel}
            >
                <MenuModal />
            </CustomModal>
            {isAdmin && isShowActions ? (
                <LendingActions
                    className={'navbar-lending-actions'}
                    onEdit={onEdit}
                    onSave={onSave}
                    onDiscard={onDiscard}
                />
            ) : null}
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        isAdmin: state.authState.user?.isAdmin,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSave: (settings, success) =>
            dispatch(
                fetchFrontOptions(
                    {
                        name: 'navbar',
                        data: settings,
                    },
                    success
                )
            ),
    };
};

export const MenuCompactModalConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuCompactModal);

function MenuModal() {
    const {
        settings: {
            navbar: { settings, setSettings },
        },
    } = useContext(Context);
    const { type, links } = settings;

    function updateSettings(setter) {
        setSettings((prevState) => ({
            ...prevState,
            settings: setter(prevState.settings),
        }));
    }

    function updateLinks(setter) {
        setSettings((prevState) => ({
            ...prevState,
            settings: {
                ...prevState.settings,
                links: setter(prevState.settings.links),
            },
        }));
    }

    function onAdd() {
        updateLinks((prevState) => {
            return [...prevState, { url: '', title: '', id: uuid() }];
        });
    }

    function onDeleteColumn(id) {
        updateLinks((prevState) => filter(prevState, (item) => item.id !== id));
    }

    function onUpdateColumn(id, value) {
        updateLinks((prevState) =>
            map(prevState, (column) =>
                column.id === id ? { ...column, ...value } : column
            )
        );
    }

    function onChangeOrderColumn(id, up) {
        updateLinks((prevState) => {
            const index = findIndex(prevState, (column) => column.id === id);
            if (index === -1) return;
            return swapArrayLoc(prevState, index, up ? index - 1 : index + 1);
        });
    }

    function onMenuType(checked) {
        updateSettings((prevState) => {
            return {
                ...prevState,
                type: Number(checked),
            };
        });
    }

    const isCompact = type === MenuTypes.compact;

    return (
        <div>
            <Space direction={'vertical'} style={{ width: '100%' }}>
                Компактное меню
                <Switch onChange={onMenuType} checked={isCompact} />
                {isCompact ? (
                    <>
                        <Button
                            onClick={onAdd}
                            icon={<PlusOutlined />}
                            className={'add-new-column-btn'}
                        >
                            Добавить столбец
                        </Button>
                        <Collapse>
                            {map(links, (column, index, array) => {
                                const { title, url, id } = column;
                                return (
                                    <Panel
                                        header={title}
                                        key={id}
                                        extra={
                                            <Space>
                                                <MinusOutlined
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onDeleteColumn(id);
                                                    }}
                                                />
                                                {index === 0 ? null : (
                                                    <ArrowUpOutlined
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            onChangeOrderColumn(
                                                                id,
                                                                true
                                                            );
                                                        }}
                                                    />
                                                )}
                                                {index ===
                                                array.length - 1 ? null : (
                                                    <ArrowDownOutlined
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            onChangeOrderColumn(
                                                                id,
                                                                false
                                                            );
                                                        }}
                                                    />
                                                )}
                                            </Space>
                                        }
                                    >
                                        <MenuItem
                                            key={id}
                                            itemId={id}
                                            url={url}
                                            title={title}
                                            onUpdateColumn={onUpdateColumn}
                                        />
                                    </Panel>
                                );
                            })}
                        </Collapse>
                    </>
                ) : null}
            </Space>
        </div>
    );
}

function MenuItem({ title, url, itemId, onUpdateColumn }) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
            }}
            className="collapse-input"
        >
            <Input
                placeholder={'Название'}
                value={title}
                onChange={(event) =>
                    onUpdateColumn(itemId, {
                        title: event.target.value,
                    })
                }
            />
            <Input
                placeholder={'Ссылка'}
                value={url}
                onChange={(event) =>
                    onUpdateColumn(itemId, {
                        url: event.target.value,
                    })
                }
            />
        </div>
    );
}
